import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Bridge component pour le retour haptique natif iOS.
//
// Placé une seule fois dans le layout (sur <body>), il écoute les soumissions
// de formulaires Turbo et déclenche le retour haptique approprié côté iOS
// quand le formulaire a un attribut data-haptic.
//
// Types disponibles (correspondent aux générateurs UIKit côté iOS) :
//   "success"        → UINotificationFeedbackGenerator .success (réservation confirmée, etc.)
//   "warning"        → UINotificationFeedbackGenerator .warning
//   "error"          → UINotificationFeedbackGenerator .error (envoyé automatiquement si échec)
//   "selection"      → UISelectionFeedbackGenerator (toggle favori, choix dans une liste)
//   "impact-light"   → UIImpactFeedbackGenerator .light
//   "impact-medium"  → UIImpactFeedbackGenerator .medium
//   "impact-heavy"   → UIImpactFeedbackGenerator .heavy
//
// Usage dans une vue ERB :
//   form_for @reservation, data: { haptic: "success" } do |f|
//   button_to path, form: { data: { haptic: "selection" } }
export default class extends BridgeComponent {
  static component = 'haptic'

  connect() {
    super.connect()
    this.boundHandler = this.#handleSubmitEnd.bind(this)
    document.addEventListener('turbo:submit-end', this.boundHandler)
    window.addEventListener('haptic:trigger', this.#handleTriggerEvent)
  }

  disconnect() {
    document.removeEventListener('turbo:submit-end', this.boundHandler)
    window.removeEventListener('haptic:trigger', this.#handleTriggerEvent)
    super.disconnect()
  }

  // Pour les contrôleurs Stimulus ordinaires, qui ne peuvent pas parler au pont
  // eux-mêmes : window.dispatchEvent(new CustomEvent('haptic:trigger', { detail: { type } }))
  #handleTriggerEvent = ({ detail: { type = 'selection' } = {} }) => {
    this.send('trigger', { type })
  }

  // Allows triggering haptics directly from data-action,
  // without depending on a form submission (e.g. favorite button).
  // Usage: data-action="bridge--haptic#trigger" data-bridge--haptic-type-param="selection"
  trigger({ params: { type = 'success' } = {} }) {
    this.send('trigger', { type })
  }

  #handleSubmitEnd(event) {
    const form = event.target
    const hapticType = form.dataset.haptic
    if (!hapticType) return

    // Si le submit a échoué, toujours envoyer "error" quelle que soit la valeur data-haptic
    const type = event.detail.success ? hapticType : 'error'
    this.send('trigger', { type })
  }
}
